













































































































import { Component, Vue } from "vue-property-decorator";
import { storeComplaintResponse } from "@/store/modules/ComplaintResponseStore";

@Component
export default class ComplaintResponseDashboard extends Vue {
  storeModule = storeComplaintResponse;

  mounted() {
    this.storeModule.loadDashboard();
  }

  get dashboard() {
    return this.storeModule.dashboard;
  }

  get capaianClass() {
    if (!this.dashboard) return "";
    return this.dashboard.bulan_ini.status_target === "tercapai"
      ? "green--text"
      : "red--text";
  }

  gradingColor(val: string) {
    const m: any = { merah: "#D32F2F", kuning: "#B8860B", hijau: "#388E3C" };
    return m[val] || "grey";
  }

  gradingBg(val: string) {
    const m: any = { merah: "red lighten-5", kuning: "yellow lighten-5", hijau: "green lighten-5" };
    return m[val] || "";
  }

  gradingBatas(val: string) {
    const m: any = { merah: "≤ 24 jam", kuning: "≤ 3 hk", hijau: "≤ 7 hk" };
    return m[val] || "-";
  }
}
